//import union from 'lodash/union'
import {
  UPDATE_REPORT_FILTERS,
  CLEAR_REPORT_FILTERS,
  MGMT_REPORT_TOTAL_REQUEST,
  MGMT_REPORT_TOTAL_SUCCESS,
  MGMT_REPORT_TOTAL_FAILURE,
  MGMT_REPORT_COURTESY_REQUEST,
  MGMT_REPORT_COURTESY_SUCCESS,
  MGMT_REPORT_COURTESY_FAILURE,
  MGMT_REPORT_SUSPENSION_REQUEST,
  MGMT_REPORT_SUSPENSION_SUCCESS,
  MGMT_REPORT_SUSPENSION_FAILURE,
  MGMT_REPORT_FINE_REQUEST,
  MGMT_REPORT_FINE_SUCCESS,
  MGMT_REPORT_FINE_FAILURE,
  MGMT_REPORT_VIOLATION_TYPE_REQUEST,
  MGMT_REPORT_VIOLATION_TYPE_SUCCESS,
  MGMT_REPORT_VIOLATION_TYPE_FAILURE,
  REPORT_COMPANY_LIST_REQUEST,
  REPORT_COMPANY_LIST_SUCCESS,
  REPORT_COMPANY_LIST_FAILURE,
  SET_FIRM,
  RESET_FIRM,
  FIRM_REPORT_TOTAL_REQUEST,
  FIRM_REPORT_TOTAL_SUCCESS,
  FIRM_REPORT_TOTAL_FAILURE,
  FIRM_REPORT_SUSPENSION_REQUEST,
  FIRM_REPORT_SUSPENSION_SUCCESS,
  FIRM_REPORT_SUSPENSION_FAILURE,
  FIRM_REPORT_VIOLATION_TYPE_REQUEST,
  FIRM_REPORT_VIOLATION_TYPE_SUCCESS,
  FIRM_REPORT_VIOLATION_TYPE_FAILURE,
  FIRM_REPORT_FINE_REQUEST,
  FIRM_REPORT_FINE_SUCCESS,
  FIRM_REPORT_FINE_FAILURE,
  REPORT_AGENT_LIST_REQUEST,
  REPORT_AGENT_LIST_SUCCESS,
  REPORT_AGENT_LIST_FAILURE,
  SET_AGENT,
  RESET_AGENT,
  AGENT_REPORT_TOTAL_REQUEST,
  AGENT_REPORT_TOTAL_SUCCESS,
  AGENT_REPORT_TOTAL_FAILURE,
  AGENT_REPORT_FINE_REQUEST,
  AGENT_REPORT_FINE_SUCCESS,
  AGENT_REPORT_FINE_FAILURE,
  MGMT_REPORT_VCBYTYPE_REQUEST,
  MGMT_REPORT_VCBYTYPE_SUCCESS,
  MGMT_REPORT_VCBYTYPE_FAILURE,
  FIRM_REPORT_VCBYTYPE_REQUEST,
  FIRM_REPORT_VCBYTYPE_SUCCESS,
  FIRM_REPORT_VCBYTYPE_FAILURE,
  AGENT_REPORT_VCBYTYPE_REQUEST,
  AGENT_REPORT_VCBYTYPE_SUCCESS,
  AGENT_REPORT_VCBYTYPE_FAILURE,
  MGMT_REPORT_CORRECTEDVC_REQUEST,
  MGMT_REPORT_CORRECTEDVC_SUCCESS,
  MGMT_REPORT_CORRECTEDVC_FAILURE,
  FIRM_REPORT_CORRECTEDVC_REQUEST,
  FIRM_REPORT_CORRECTEDVC_SUCCESS,
  FIRM_REPORT_CORRECTEDVC_FAILURE,
  AGENT_REPORT_CORRECTEDVC_REQUEST,
  AGENT_REPORT_CORRECTEDVC_SUCCESS,
  AGENT_REPORT_CORRECTEDVC_FAILURE,
} from "actions/reports";

export default (
  state = {
    reportFilters: {},
    isMRTotalFetching: false,
    managementReportTotal: {},
    isMRCourtesyFetching: false,
    managementReportCourtesy: 0,
    isMRSuspensionFetching: false,
    managementReportSuspension: 0,
    isMRFineFetching: false,
    managementReportFine: {},
    isMRVTWiseFetching: false,
    managementReportVTWise: [],
    isCompaniesFetching: false,
    companies: [],
    selectedFirm: {},
    isFRTotalFetching: false,
    firmReportTotal: {},
    isFRSuspensionFetching: false,
    firmReportSuspension: 0,
    isFRVTWiseFetching: false,
    firmReportVTWise: [],
    isFRFineFetching: false,
    firmReportFine: {},
    isAgentsFetching: false,
    agents: [],
    selectedAgent: {},
    isARTotalFetching: false,
    agentReportTotal: {},
    isARFineFetching: false,
    agentReportFine: {},
    isMRVTWiseVCFetching: false,
    managementReportVTWiseVC: {},
    isFRVTWiseVCFetching: false,
    firmReportVTWiseVC: [],
    isARVTWiseVCFetching: false,
    agentReportVTWiseVC: [],
    isMRCorrectedVCFetching: false,
    managementReportCorrectedVC: [],
    isFRCorrectedVCFetching: false,
    firmReportCorrectedVC: [],
    isARCorrectedVCFetching: false,
    agentReportCorrectedVC: [],
  },
  action
) => {
  switch (action.type) {
    case UPDATE_REPORT_FILTERS:
      return {
        ...state,
        reportFilters: { ...state.reportFilters, ...action.params },
      };
    case CLEAR_REPORT_FILTERS:
      return {
        ...state,
        reportFilters: {},
      };
    case MGMT_REPORT_TOTAL_REQUEST:
      return {
        ...state,
        isMRTotalFetching: true,
      };
    case MGMT_REPORT_TOTAL_SUCCESS:
      return {
        ...state,
        isMRTotalFetching: false,
        managementReportTotal: action.response,
        error: undefined,
      };
    case MGMT_REPORT_TOTAL_FAILURE:
      return {
        ...state,
        isMRTotalFetching: false,
        error: action.error,
      };
    case MGMT_REPORT_COURTESY_REQUEST:
      return {
        ...state,
        isMRCourtesyFetching: true,
      };
    case MGMT_REPORT_COURTESY_SUCCESS:
      return {
        ...state,
        isMRCourtesyFetching: false,
        managementReportCourtesy: action.response,
        error: undefined,
      };
    case MGMT_REPORT_COURTESY_FAILURE:
      return {
        ...state,
        isMRCourtesyFetching: false,
        error: action.error,
      };
    case MGMT_REPORT_SUSPENSION_REQUEST:
      return {
        ...state,
        isMRSuspensionFetching: true,
      };
    case MGMT_REPORT_SUSPENSION_SUCCESS:
      return {
        ...state,
        isMRSuspensionFetching: false,
        managementReportSuspension: action.response,
        error: undefined,
      };
    case MGMT_REPORT_SUSPENSION_FAILURE:
      return {
        ...state,
        isMRSuspensionFetching: false,
        error: action.error,
      };
    case MGMT_REPORT_FINE_REQUEST:
      return {
        ...state,
        isMRFineFetching: true,
      };
    case MGMT_REPORT_FINE_SUCCESS:
      return {
        ...state,
        isMRFineFetching: false,
        managementReportFine: action.response,
        error: undefined,
      };
    case MGMT_REPORT_FINE_FAILURE:
      return {
        ...state,
        isMRFineFetching: false,
        error: action.error,
      };
    case MGMT_REPORT_VIOLATION_TYPE_REQUEST:
      return {
        ...state,
        isMRVTWiseFetching: true,
      };
    case MGMT_REPORT_VIOLATION_TYPE_SUCCESS:
      return {
        ...state,
        isMRVTWiseFetching: false,
        managementReportVTWise: action.response,
        error: undefined,
      };
    case MGMT_REPORT_VIOLATION_TYPE_FAILURE:
      return {
        ...state,
        isMRVTWiseFetching: false,
        error: action.error,
      };
    case REPORT_COMPANY_LIST_REQUEST:
      return {
        ...state,
        isCompaniesFetching: true,
      };
    case REPORT_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        isCompaniesFetching: false,
        companies: action.response,
        error: undefined,
      };
    case REPORT_COMPANY_LIST_FAILURE:
      return {
        ...state,
        isCompaniesFetching: false,
        error: action.error,
      };

    case SET_FIRM:
      return {
        ...state,
        selectedFirm: Object.assign({}, action.params),
      };
    case RESET_FIRM:
      return {
        ...state,
        selectedFirm: {},
      };
    case FIRM_REPORT_TOTAL_REQUEST:
      return {
        ...state,
        isFRTotalFetching: true,
      };
    case FIRM_REPORT_TOTAL_SUCCESS:
      return {
        ...state,
        isFRTotalFetching: false,
        firmReportTotal: action.response,
        error: undefined,
      };
    case FIRM_REPORT_TOTAL_FAILURE:
      return {
        ...state,
        isFRTotalFetching: false,
        error: action.error,
      };
    case FIRM_REPORT_SUSPENSION_REQUEST:
      return {
        ...state,
        isFRSuspensionFetching: true,
      };
    case FIRM_REPORT_SUSPENSION_SUCCESS:
      return {
        ...state,
        isFRSuspensionFetching: false,
        firmReportSuspension: action.response,
        error: undefined,
      };
    case FIRM_REPORT_SUSPENSION_FAILURE:
      return {
        ...state,
        isFRSuspensionFetching: false,
        error: action.error,
      };
    case FIRM_REPORT_VIOLATION_TYPE_REQUEST:
      return {
        ...state,
        isFRVTWiseFetching: true,
      };
    case FIRM_REPORT_VIOLATION_TYPE_SUCCESS:
      return {
        ...state,
        isFRVTWiseFetching: false,
        firmReportVTWise: action.response,
        error: undefined,
      };
    case FIRM_REPORT_VIOLATION_TYPE_FAILURE:
      return {
        ...state,
        isFRVTWiseFetching: false,
        error: action.error,
      };
    case FIRM_REPORT_FINE_REQUEST:
      return {
        ...state,
        isFRFineFetching: true,
      };
    case FIRM_REPORT_FINE_SUCCESS:
      return {
        ...state,
        isFRFineFetching: false,
        firmReportFine: action.response,
        error: undefined,
      };
    case FIRM_REPORT_FINE_FAILURE:
      return {
        ...state,
        isFRFineFetching: false,
        error: action.error,
      };

    case REPORT_AGENT_LIST_REQUEST:
      return {
        ...state,
        isAgentsFetching: true,
      };
    case REPORT_AGENT_LIST_SUCCESS:
      return {
        ...state,
        isAgentsFetching: false,
        agents: action.response,
        error: undefined,
      };
    case REPORT_AGENT_LIST_FAILURE:
      return {
        ...state,
        isAgentsFetching: false,
        error: action.error,
      };

    case SET_AGENT:
      return {
        ...state,
        selectedAgent: Object.assign({}, action.params),
      };
    case RESET_AGENT:
      return {
        ...state,
        selectedAgent: {},
      };
    case AGENT_REPORT_TOTAL_REQUEST:
      return {
        ...state,
        isARTotalFetching: true,
      };
    case AGENT_REPORT_TOTAL_SUCCESS:
      return {
        ...state,
        isARTotalFetching: false,
        agentReportTotal: action.response,
        error: undefined,
      };
    case AGENT_REPORT_TOTAL_FAILURE:
      return {
        ...state,
        isARTotalFetching: false,
        error: action.error,
      };
    case AGENT_REPORT_FINE_REQUEST:
      return {
        ...state,
        isARFineFetching: true,
      };
    case AGENT_REPORT_FINE_SUCCESS:
      return {
        ...state,
        isARFineFetching: false,
        agentReportFine: action.response,
        error: undefined,
      };
    case AGENT_REPORT_FINE_FAILURE:
      return {
        ...state,
        isARFineFetching: false,
        error: action.error,
      };
    case MGMT_REPORT_VCBYTYPE_REQUEST:
      return {
        ...state,
        isMRVTWiseVCFetching: true,
      };
    case MGMT_REPORT_VCBYTYPE_SUCCESS:
      return {
        ...state,
        isMRVTWiseVCFetching: false,
        managementReportVTWiseVC: action.response,
        error: undefined,
      };
    case MGMT_REPORT_VCBYTYPE_FAILURE:
      return {
        ...state,
        isMRVTWiseVCFetching: false,
        error: action.error,
      };
    case FIRM_REPORT_VCBYTYPE_REQUEST:
      return {
        ...state,
        isFRVTWiseVCFetching: true,
      };
    case FIRM_REPORT_VCBYTYPE_SUCCESS:
      return {
        ...state,
        isFRVTWiseVCFetching: false,
        firmReportVTWiseVC: action.response,
        error: undefined,
      };
    case FIRM_REPORT_VCBYTYPE_FAILURE:
      return {
        ...state,
        isFRVTWiseVCFetching: false,
        error: action.error,
      };
    case AGENT_REPORT_VCBYTYPE_REQUEST:
      return {
        ...state,
        isARVTWiseVCFetching: true,
      };
    case AGENT_REPORT_VCBYTYPE_SUCCESS:
      return {
        ...state,
        isARVTWiseVCFetching: false,
        agentReportVTWiseVC: action.response,
        error: undefined,
      };
    case AGENT_REPORT_VCBYTYPE_FAILURE:
      return {
        ...state,
        isARVTWiseVCFetching: false,
        error: action.error,
      };
    case MGMT_REPORT_CORRECTEDVC_REQUEST:
      return {
        ...state,
        isMRCorrectedVCFetching: true,
      };
    case MGMT_REPORT_CORRECTEDVC_SUCCESS:
      return {
        ...state,
        isMRCorrectedVCFetching: false,
        managementReportCorrectedVC: action.response,
        error: undefined,
      };
    case MGMT_REPORT_CORRECTEDVC_FAILURE:
      return {
        ...state,
        isMRCorrectedVCFetching: false,
        error: action.error,
      };
    case FIRM_REPORT_CORRECTEDVC_REQUEST:
      return {
        ...state,
        isFRCorrectedVCFetching: true,
      };
    case FIRM_REPORT_CORRECTEDVC_SUCCESS:
      return {
        ...state,
        isFRCorrectedVCFetching: false,
        firmReportCorrectedVC: action.response,
        error: undefined,
      };
    case FIRM_REPORT_CORRECTEDVC_FAILURE:
      return {
        ...state,
        isFRCorrectedVCFetching: false,
        error: action.error,
      };
    case AGENT_REPORT_CORRECTEDVC_REQUEST:
      return {
        ...state,
        isARCorrectedVCFetching: true,
      };
    case AGENT_REPORT_CORRECTEDVC_SUCCESS:
      return {
        ...state,
        isARCorrectedVCFetching: false,
        agentReportCorrectedVC: action.response,
        error: undefined,
      };
    case AGENT_REPORT_CORRECTEDVC_FAILURE:
      return {
        ...state,
        isARCorrectedVCFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
};
